import TrailDetailsOverviewLink from '../enums/TrailDetailsOverviewLink';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsOverviewLinkClickedParams = {
  overview_link_clicked?: TrailDetailsOverviewLink;
  trail_id: number;
};

/**
 * User clicks one of the overview links on the web trail page
 * @param params - Attributes to log with the amplitude event
 * @param params.overview_link_clicked - The overview link clicked.
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsOverviewLinkClicked = ({ overview_link_clicked, trail_id }: logTrailDetailsOverviewLinkClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'trail details overview link clicked',
    { 'overview link clicked': overview_link_clicked, 'trail id': trail_id },
    callback
  );
};

export default logTrailDetailsOverviewLinkClicked;
